// extracted by mini-css-extract-plugin
module.exports = {"theme_switch":"App_theme_switch__2RiCE"};